<template>
  <div class="preview" style="overflow-x: scroll">
    <loading-cube v-if="loading"/>

    <div v-if="error">
      Error: Cannot fetch the summary for dates {{ start_date }} - {{ end_date }}. Please try again later and failing that contact support.
    </div>
    <div v-if="!loading && !error" class="preview-container">
      <div class="dates">
        <h1><i class="fas fa-calendar-alt"></i>Worker Summaries for Period: {{ start_date }} - {{ end_date }}</h1>
        <p>
          The following is a preview per worker for all payments entered. Any workers highlighted in
          green have had their payments submitted for this pay
          period.
        </p>
      </div>

      <div>
        <b-card
            :header="`Submission Information for pay period: ${submissionDate.start_date} - ${submissionDate.end_date}`"
            body-class="mb-3 pb-0 record_card_body"
            header-tag="h4"
        >
          <div class="row">
            <div class="col-12">
              <div v-for="(si, i) in submission_info" class="row mb-2">
                <div class="col-lg-5">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="mb-0 bp_color">{{ si.order_ref }} - {{ si.job_title }}</h4>
                      <p v-if="si.alt_address_name" class="mb-2">{{ si.alt_address_name }}</p>
                      <p v-else class="mb-2">{{ si.job_address_full }}</p>
                    </div>
                    <div class="col-md-8"><span class="font-weight-bold">Total Workers</span></div>
                    <div class="col-md-4">{{ si.ts_records_length }}</div>
                    <div class="col-md-8"><span class="font-weight-bold">Total Order Cost</span></div>
                    <div class="col-md-4">{{ si.total_price | currency }}</div>
                    <div class="col-md-8"><span class="font-weight-bold">Total Retention Held</span></div>
                    <div class="col-md-4 mb-2">{{ si.retention_amount | currency }}</div>
                  </div>
                </div>
                <div class="col-lg-7 mb-3 mt-1 text-right">
                  <div class="chart">
                    <VueApexCharts
                        :options="workerChartOptions"
                        :series="si.totalWorkerSubmitted"
                        height="125"
                        type="radialBar">
                    </VueApexCharts>
                  </div>
                  <div class="chart">
                    <VueApexCharts
                        :options="authChartOptions"
                        :series="si.totalAuths"
                        height="125"
                        type="radialBar">
                    </VueApexCharts>
                  </div>
                  <div class="chart">
                    <VueApexCharts
                        :options="submissionChartOptions"
                        :series="si.totalCompanySubmitted"
                        height="125"
                        type="radialBar">
                    </VueApexCharts>
                  </div>
                </div>
                <div class="col-12">
                  <hr v-if="i !== Object.keys(submission_info).length - 1" class="mt-0 mb-0">
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <paginator
          :callback="paginate"
          :page="this.submission_info_pagination.page"
          :pages="this.submission_info_pagination.pages"
          :perPage="20"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.dates {
  border: 1px solid #eee;
  padding: 20px;
  margin-bottom: 10px;

  i {
    $size: 50px;
    color: white;
    width: $size;
    height: $size;
    text-align: center;
    line-height: $size;
    vertical-align: middle;
    background-color: $bc_1;
    border-radius: $border-radius;
    margin-right: 10px;
  }

  p {
    font-size: 18px;
  }
}

.chart {
  max-width: 140px;
  width: 140px;
  display: inline-block;
  margin: 0 5px;
}

.chart,
.chart-box {
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 22px 35px -16px rgb(0 0 0 / 10%);
}
</style>
<script>
import loadingCube from "loaders/record_loader.vue";
import paginator from "../components/paginator.vue";
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "timesheet_preview_all",
  components: {
    paginator,
    loadingCube,
    VueApexCharts
  },
  props: {
    start_date: {required: true},
    end_date: {required: true}
  },
  async beforeMount() {
    this.loading = true;
    this.submissionDate = {
      end_date: this.end_date,
      start_date: this.start_date
    };

    await this.getSummaryData(0);

    this.loading = false;
  },
  methods: {
    async paginate(newPage) {
      this.loading = true;
      await this.getSummaryData(newPage)
      this.loading = false;
    },
    reloadRoute() {
      this.$router.go();
    },
    async getSummaryData(page) {

      page = parseInt(page);

      let selected_date = this.submissionDate.start_date;

      let res = await axios.get(this.crmApiPath + 'timesheet/week_starting_info/get/' + this.$store.state.auth.me.contact_id, {
        params: {
          week_end_date: selected_date,
          page_length: 20,
          page
        }
      });

      if (res.status !== 200) {
        this.error = true;
        console.error('Could not get summary data');
      }

      this.submission_info = res.data.data;
      this.submission_info.map((si, i) => ({
        ...si,
        totalAuths: this.totalAuths(si.ts_records_length, si.ts_records_company_submitted),
        totalWorkerSubmitted: this.totalWorkerSubmitted(si.ts_records_length, si.ts_records_worker_submitted),
        totalCompanySubmitted: this.totalCompanySubmitted(si.ts_records_length, si.ts_records_company_submitted)
      }));

      this.submission_info_pagination.page = parseInt(res.data.pagination.page);
      this.submission_info_pagination.pages = parseInt(res.data.pagination.pages);
    },
    totalWorkerSubmitted(total, ws) {
      return ws !== 0 ? [(ws * 100) / total] : [0];
    },
    totalAuths(total, ta) {
      return ta !== 0 ? [(ta * 100) / total] : [0];
    },
    totalCompanySubmitted(total, cs) {
      return cs !== 0 ? [(cs * 100) / total] : [0];
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      submissionDate: null,
      submission_info: [],
      submission_info_pagination: {
        page: 0,
        pages: 0
      },
      showPagination: false,
      workerChartOptions: worker_chart_options,
      authChartOptions: auth_chart_options,
      submissionChartOptions: submission_chart_options
    }
  },
};

const worker_chart_options = {
  chart: {
    // height: 125,
    width: '100%',
    type: 'radialBar',
    offsetY: -10,
    redrawOnParentResize: true,
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350
      }
    }
  },
  plotOptions: {
    radialBar: {
      startAngle: -135,
      endAngle: 135,
      dataLabels: {
        name: {
          fontSize: '12px',
          color: undefined,
          offsetY: 58
        },
        value: {
          offsetY: 26,
          fontSize: '16px',
          color: undefined,
          formatter: function (val) {
            return parseFloat(val).toFixed(2) + '%';
          }
        }
      },
    }
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'dark',
      shadeIntensity: 0.15,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 50, 65, 91]
    },
  },
  stroke: {
    dashArray: 4
  },
  labels: ['Worker Submitted'],
};

const auth_chart_options = {
  chart: {
    // height: 125,
    width: '100%',
    type: 'radialBar',
    offsetY: -10,
    redrawOnParentResize: true,
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350
      }
    }
  },
  plotOptions: {
    radialBar: {
      startAngle: -135,
      endAngle: 135,
      dataLabels: {
        name: {
          fontSize: '12px',
          color: undefined,
          offsetY: 58
        },
        value: {
          offsetY: 26,
          fontSize: '16px',
          color: undefined,
          formatter: function (val) {
            return parseFloat(val).toFixed(2) + '%';
          }
        }
      },
    }
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'dark',
      shadeIntensity: 0.15,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 50, 65, 91]
    },
  },
  stroke: {
    dashArray: 4
  },
  labels: ['Your Authorisations'],
}

const submission_chart_options = {
  chart: {
    // height: 125,
    width: '100%',
    type: 'radialBar',
    offsetY: -10,
    redrawOnParentResize: true,
    animations: {
      enabled: true,
      easing: 'easeinout',
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350
      }
    }
  },
  plotOptions: {
    radialBar: {
      startAngle: -135,
      endAngle: 135,
      dataLabels: {
        name: {
          fontSize: '12px',
          color: undefined,
          offsetY: 58
        },
        value: {
          offsetY: 26,
          fontSize: '16px',
          color: undefined,
          formatter: function (val) {
            return parseFloat(val).toFixed(2) + '%';
          }
        }
      }
    }
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'dark',
      shadeIntensity: 0.15,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 1,
      stops: [0, 50, 65, 91]
    },
  },
  stroke: {
    dashArray: 4
  },
  labels: ['Submitted'],
};
</script>
